export default {
    CSVNUMBERS: 'csv-numbers',
    NUMBERS: 'numbers',
    /** @type {'/numbers/tpm'} */
    NUMBERS_TPM: '/numbers/tpm',
};
